<template>
  <ContentPage back>
    <template #header>
      <content-page-title v-if="!isRefunded">
        {{ currentLead.customer.name }}
      </content-page-title>
      <content-page-title v-else>
        Refunded Lead
      </content-page-title>      
    </template>

    <Lead :lead="currentLead" />
    <Notes v-if="!isRefunded" :lead="currentLead" />
    <Review v-if="showReview" :lead="currentLead" />
    <ErrorOverlay
      title="Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'
import ErrorOverlay from '@/components/pages/ErrorOverlay'
import { Lead, Notes, Review } from './sections'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: { 
    ContentPage, ContentPageTitle, ErrorOverlay, Lead, Notes, Review 
  },

  props: ['lead_id'],

  data: () => ({    
    // error handling
    loading: false,
    error_dialog: false,
    error_message: '',
  }),

  computed: {
    ...mapGetters('leads', ['currentLead']),

    isRefunded() {
      return this.currentLead.system_status == 'refunded'
    },

    showReview() {
      const lead = this.currentLead
      return lead.system_status == 'rewarded' || 
             lead.system_status == 'disputed' || 
             lead.system_status == 'refunded' 
    },
  },

  methods: {
    ...mapActions('leads', ['loadCurrent']),
  },

  async created() {
    this.loading = true
    const result = await this.loadCurrent( { lead_id: this.lead_id } )
    this.loading = false

    if (!result.ok) {
      this.error_dialog = true
      this.error_message = result.error
    }
  }
}
</script>
